<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Pridėti IDK</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <v-row>
              <v-col cols="12" v-if="modalloading">
                <v-alert dense outlined type="info">
                  Tikrinami dokumentai
                </v-alert>
              </v-col>
              <v-col cols="12" v-if="showError">
                <v-alert dense outlined type="error">
                  {{ errorMsg }}
                </v-alert>
              </v-col>
              <v-col cols="12">
                <el-textarea
                  required
                  :readonly="modalloading"
                  :counter="2000"
                  label="Identifikacinių kodų (IDK) sąrašas"
                  tooltip="Modalas perleidimas. IDK sąrašas"
                  v-model="idkInput"
                  autofocus
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()" :loading="modalloading">
          Atšaukti
        </el-button>
        <el-button primary @click.native="saveData()" :loading="modalloading">
          Saugoti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalPerleidimasObjektas',
  props: {
    value: Boolean,
  },
  data() {
    return {
      loading: false,
      modalloading: false,
      idkInput: '',
      showError: false,
      errorMsg: false,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    idkList() {
      return [
        ...new Set(
          this.idkInput
            .replaceAll(' ', '\n')
            .replaceAll(',', '\n')
            .replaceAll(';', '\n')
            .split('\n')
            .filter(Number)
        ),
      ]
    },
  },
  created() {
    //
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          if (this.idkList.length == 0) {
            this.errorMsg = 'Neįvesti teisingi IDK'
            this.showError = true
            return
          }
          this.showError = false
          this.modalloading = true
          this.$emit('savedData', this.idkList)
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
